import React from "react";
import ReactTooltip from "react-tooltip";
import {
  participationAccessSettings,
  participationAnonymitySettings,
} from "../../../util/Templates";
import "./ParticipationSetting.scss";

export const ParticipationSetting = ({
  accessSetting,
  anonymitySetting,
  isAnonymitySettingEditable,
  onAccessSettingChange,
  onAnonymitySettingChange,
}) => {
  const isNamedDisabled =
    accessSetting === "anyone_as_guest" || !isAnonymitySettingEditable;
  return (
    <div className="participation-setting">
      <div className="access setting-list">
        {participationAccessSettings.map((setting, idx) => (
          <div key={idx} className="setting-option">
            <input
              type="radio"
              id={setting.value}
              value={setting.value}
              checked={setting.value === accessSetting}
              onChange={onAccessSettingChange}
            />
            <label htmlFor={setting.value}>{setting.title}</label>
            <div>
              {setting.features.map((feature, idx) => (
                <div key={idx} className="with-icon">
                  <i className="material-icons">{feature.icon}</i>
                  <div>{feature.title}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <hr />

      <div className="anonymity setting-list">
        {participationAnonymitySettings.map((setting, idx) => (
          <div
            key={idx}
            className={`setting-option ${
              isNamedDisabled && idx === 1 ? "disabled" : ""
            }`}
          >
            <input
              type="radio"
              id={setting.value}
              value={setting.value}
              checked={setting.value === anonymitySetting}
              onChange={onAnonymitySettingChange}
              disabled={isNamedDisabled && idx === 1}
            />
            <label
              htmlFor={setting.value}
              data-tip
              data-for={idx === 1 ? "named" : ""}
            >
              {setting.title}
            </label>
            <div className="description">{setting.description}</div>
            <div className="explanation">{setting.explanation}</div>
          </div>
        ))}
      </div>

      <ReactTooltip id="named">
        {isAnonymitySettingEditable
          ? "Named is only available for Restricted or Private POPins"
          : "This cannot be changed because there has been some participation"}
      </ReactTooltip>
    </div>
  );
};

export default ParticipationSetting;
